import { NOT_FOUND } from 'redux-first-router';

export default (state = 'START', action = {}) => components[action.type] || state;

const components = {
	START: 'Page',
	CATEGORY_PRODUCT_PAGE: 'CatchAll',
	[NOT_FOUND]: 'Page',
};
